import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { inlineMediaUrl } from '../../inlineMediaUrl';
import { SerializedReel } from '../../types';
import { reelMessages, reelVoiceMessages } from './reelMessages';
import { releaseThemeMessages } from '../../themes/releaseThemeMessages';

import { reelProgressMessages } from './reelProgressMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The small reel row at the top of the approve sheet (design d1): poster, release, choices. */
const ReelSheetReelComponent: React.FC<{ reel: SerializedReel; releaseTitle?: string }> = ({ reel, releaseTitle }) => {
  const intl = useIntl();
  const posterUrl = reel.video?.posterUrl ?? null;
  const choices = [
    intl.formatMessage(releaseThemeMessages[reel.themeId].name),
    intl.formatMessage(reel.voiceId === null ? reelMessages.noVoiceover : reelVoiceMessages[reel.voiceId].label),
    intl.formatMessage(reelMessages.seconds, { count: reel.durationSec }),
  ].join(' · ');

  return (
    <div className={styles.mini}>
      {posterUrl === null ? (
        <span className={styles.miniPoster} />
      ) : (
        <img className={styles.miniPoster} src={inlineMediaUrl(posterUrl)} alt="" />
      )}
      <div>
        <span className={styles.miniTitle}>{releaseTitle ?? intl.formatMessage(reelProgressMessages.thisRelease)}</span>
        <span className={styles.miniSub}>{choices}</span>
      </div>
    </div>
  );
};

export const ReelSheetReel = TypedMemo(ReelSheetReelComponent);
